import { render, staticRenderFns } from "./UploadImageArtist.vue?vue&type=template&id=25672f21"
import script from "./UploadImageArtist.vue?vue&type=script&lang=js"
export * from "./UploadImageArtist.vue?vue&type=script&lang=js"
import style0 from "./UploadImageArtist.vue?vue&type=style&index=0&id=25672f21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports